import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const ManagerDashboardApi = createApi({
  reducerPath: "managerDashApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getGoalInfobyId: builder.query({
      query: (id: string) => ({
        url: "/graphql",
        body: gql`
          query {
            userInformationForUserId(
              userId: "${id}"
            ) {
              timestamp
              data {
                id
                userId
                totalExperience
                goalInformation {
                  description
                  objective
                }
                preferences {
                  timezone
                  location
                  language
                }
                summary
                skillTag {
                  skillId
                  skillTag
                  proficiency
                  verified
                  verificationType
                  verifiedat
                  verifiedby
                  source
                }
                org
                subscriberIdNovu
              }
            }
          }
        `
      }),
      extraOptions: { service: "Utility" }
    }),

    getUserInfoById: builder.query({
      query: (id: any) => ({
        url: "/graphql",
        body: gql`
          query {
            getProfileByIdPaginated(
              userIds: "${id}"
              pageSize: 1
              pageNumber: 1
            ) {
              data {
                profiles {
                  id
                  employeeNumber
                  name {
                    fullName
                    lastName
                    firstName
                    middleName
                  }
                  email
                  profileImageUrl
                  supervisor
                  location {
                    city
                    region
                    country
                    locationName
                    workingLocation
                  }
                  employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }
                  billing {
                    billingBg
                    billingRole
                    billingRoleEndDate
                    billingRoleStartDate
                  }
                  project {
                    projectName
                    projectNumber
                    projectManager
                    allocationEndDate
                    allocationStartDate
                  }
                  enabled
                }
              }
              error
              timestamp
              version
            }
          }
        `
      }),
      extraOptions: { service: "PID" }
    }),

    getManagerDashboardAccess: builder.query({
      query: ({ userId }) => ({
        url: `/pid/profile/manager-dashboard/access/${userId}`,
        method: "GET"
      }),
      extraOptions: {
        service: "PID"
      }
    })
  })
});

export const {
  useGetGoalInfobyIdQuery,
  useLazyGetGoalInfobyIdQuery,
  useGetUserInfoByIdQuery,
  useLazyGetUserInfoByIdQuery,
  useGetManagerDashboardAccessQuery,
  useLazyGetManagerDashboardAccessQuery
} = ManagerDashboardApi;
